import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-manage-all-asset-logins",
	templateUrl: "./manage-all-asset-logins.component.html",
	styleUrls: ["./manage-all-asset-logins.component.scss"]
})
export class ManageAllAssetLoginsComponent implements OnChanges {
	@Input()
	assets: APIResults.Asset[];

	@Output()
	public AssetSelected = new EventEmitter<APIResults.Asset>();

	public goneDarkAssets: any[] = [];

	ngOnChanges() {
		this.goneDarkAssets = this.assets.sort((a, b) => (a.last_login < b.last_login) ? 1 : -1);
	}

	public async SelectAsset(target: APIResults.Asset) {
		this.AssetSelected.emit(target);
	}
}
